<risr-features-reports-report-form [report]="report()" (model)="run($event)"></risr-features-reports-report-form>

<risr-async [wrapper]="reportReady">
    @let letReportReady = reportReady.value();
    @if (letReportReady) {
        <risr-features-reports-report-result></risr-features-reports-report-result>
    }
</risr-async>
